
import {
  Component, ProvideReactive, Vue, Watch,
} from 'nuxt-property-decorator'
import BaseGridLayout from './BaseGridLayout.vue'
import BaseToolbar from '../base/toolbar/BaseToolbar.vue'
import BaseIconButton from '../base/BaseIconButton.vue'
import BaseHeadline from '../base/BaseHeadline.vue'

@Component({
  name: 'TheSidebar',
  components: {
    BaseGridLayout,
    BaseToolbar,
    BaseIconButton,
    BaseHeadline,
  },
})

export default class TheSidebar extends Vue {
  @ProvideReactive('contained') isContained : boolean = true

  private toolbarVisible : boolean = true

  $refs! : {
    sidebar ?: HTMLElement
    toolbar ?: BaseToolbar
  }

  mounted () {
    const observer = new IntersectionObserver((entries) => {
      if (!this.isMobile) return

      entries.forEach((entry) => {
        this.toolbarVisible = !entry.isIntersecting
      })
    })
    const target = document.querySelector('[data-t-name="footer"]') as HTMLElement
    observer.observe(target)
  }

  private get headline () : String {
    return this.$store.state.SidebarContent.headline
  }

  private get isMd () : boolean {
    return this.$store.getters['Viewport/isMd']
  }

  private get open () : boolean {
    return this.$store.state.Sidebar.open
  }

  private setOpenState (open : boolean) : void {
    this.$store.commit('Sidebar/set', open)
  }

  private get isMobile () : boolean {
    return this.$store.getters['Viewport/isMobile']
  }

  @Watch('$store.state.Sidebar.open')
  private onOpenChange (newValue : boolean) : void {
    if (newValue) {
      document.body.classList.add('no-scroll')
      return
    }

    document.body.classList.remove('no-scroll')
    this.$refs.toolbar?.reset()
  }

  @Watch('isMd')
  private viewPortChanged () : void {
    this.$refs.sidebar?.classList.add('noTransition')
    setTimeout(() => {
      this.$refs.sidebar?.classList.remove('noTransition')
    }, 10)
  }
}
